import { Navigate, useLocation } from "react-router-dom";

/**
 * Weiterleitung für Seiten, die weggefallen sind (Frage 292, Sitzung „Aufräumen“, 14.10.2026). Alte Links aus
 * Mails, Anzeigen, QR-Codes und Google landen so auf der Nachfolgeseite statt auf 404. Suchteil und Anker gehen
 * mit (`?utm_…`, `?ref=` für das Partnerprogramm), sonst verliert eine Anzeige ihre Zuordnung.
 */
export default function Weiterleitung({ nach }: { nach: string }) {
  const { search, hash } = useLocation();
  return <Navigate to={{ pathname: nach, search, hash }} replace />;
}
